// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"downloadPNGs_wrapper__1krEF","row":"downloadPNGs_row__eTdbQ"};